import React, { useState } from 'react';

/**
 * AddPromptModal - Modal for creating a new prompt.
 * Extracted from App.js to reduce component size.
 */
function AddPromptModal({ categories, onSave, onClose }) {
  const [promptText, setPromptText] = useState('');
  const [categoryId, setCategoryId] = useState('');

  const handleSave = () => {
    if (!promptText.trim()) {
      alert('Prompt text is required');
      return;
    }
    if (!categoryId) {
      alert('Category is required');
      return;
    }
    onSave({ promptText, categoryId });
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="modal-content add-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Add New Prompt</h2>
        <div className="form-group">
          <label htmlFor="promptText">Prompt Text *</label>
          <textarea
            id="promptText"
            value={promptText}
            onChange={(e) => setPromptText(e.target.value)}
            placeholder="Enter your prompt text..."
            rows="4"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="categoryId">Category *</label>
          <select
            id="categoryId"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
            required
          >
            <option value="">Select a category</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-save" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddPromptModal;
